import React from 'react';

// ** MUI
import { type SxProps, type Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

// ** Components
import mergeSxProps from '../shared/mergeSxProps';
import AdminOnly from './AdminOnly';

export type AdminAreaProps = {
  children: React.ReactNode;
  isVisible?: boolean;
  sx?: SxProps<Theme>;
  fullWidth?: boolean;
};

export default function AdminArea(props: AdminAreaProps) {
  'use memo';

  const { children, isVisible = true, sx, fullWidth = true } = props;
  return (
    <AdminOnly isVisible={isVisible} className="admin-area">
      <Typography
        className="admin-area"
        variant="body2"
        component="div"
        sx={mergeSxProps(
          {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 2,
            backgroundColor: 'admin.light',
            marginTop: 0,
            marginBottom: 6,
            paddingX: 2,
            paddingY: 1,
            borderRadius: 0.5,
            border: '1px solid',
            borderColor: 'admin.main',
            fontSize: '0.8rem',
            fontFamily: 'monospace',
            width: fullWidth ? '100%' : 'auto',
            overflowX: 'hidden',
          },
          sx,
        )}
      >
        {children}
      </Typography>
    </AdminOnly>
  );
}
